// Wykrywanie wydajności urządzenia ("perf tier"): 'low' | 'high'.
// Po co: słabe tablety i telefony (np. tanie Androidy) dławiają się na
// kosztownych efektach graficznych menu i planszy. Wykrywamy słaby sprzęt raz
// (heurystyka CPU/RAM + pomiar fps przez rAF), zapisujemy wynik w localStorage
// i SoundContext ustawia html[data-perf="low"], pod które są reguły CSS
// ścinające to, czego oko nie widzi, a GPU liczy co klatkę (backdrop-filter,
// blur, blend-mode, drobne cząsteczki). Animacji to NIE wyłącza — animacje
// zostają zawsze włączone (decyzja użytkownika, dają „feeling" gry).

export const PERF_TIER_KEY = 'kroniki-perf-tier'; // 'low' | 'high'

export function readStoredTier() {
  try {
    const v = localStorage.getItem(PERF_TIER_KEY);
    return v === 'low' || v === 'high' ? v : null;
  } catch {
    return null;
  }
}

// Szybka heurystyka sprzętowa — bez pomiaru, zanim cokolwiek się narysuje.
// Celowo ostrożna: same 4 rdzenie to też sprawne laptopy i telefony, więc
// bez pomiaru fps za 'low' uznajemy tylko mało RAM-u albo mało rdzeni + mało RAM-u.
export function heuristicLowTier() {
  try {
    if (typeof navigator !== 'undefined') {
      const cores = navigator.hardwareConcurrency || 0;
      const mem = navigator.deviceMemory || 0;
      if (mem && mem <= 2) return true;
      if (cores && mem && cores <= 4 && mem <= 4) return true;
    }
    if (typeof matchMedia === 'function'
      && matchMedia('(prefers-reduced-motion: reduce)').matches) return true;
  } catch { /* ignore */ }
  return false;
}

// Mierzy średni fps przez `frames` klatek requestAnimationFrame.
// Pierwsze 5 klatek odrzucamy (rozgrzewka JIT/kompozytora).
export function probeFrameRate({ frames = 60 } = {}) {
  return new Promise((resolve) => {
    if (typeof requestAnimationFrame !== 'function') return resolve(60);
    const deltas = [];
    let last = 0;
    let count = 0;
    const step = (ts) => {
      if (last) deltas.push(ts - last);
      last = ts;
      count++;
      if (count < frames) {
        requestAnimationFrame(step);
      } else {
        const measured = deltas.slice(5);
        if (!measured.length) return resolve(60);
        const avg = measured.reduce((a, b) => a + b, 0) / measured.length;
        resolve(1000 / avg);
      }
    };
    requestAnimationFrame(step);
  });
}

export async function detectTier() {
  const stored = readStoredTier();
  if (stored) return stored;
  if (heuristicLowTier()) {
    setStoredTier('low');
    return 'low';
  }
  const fps = await probeFrameRate();
  const tier = fps < 45 ? 'low' : 'high';
  setStoredTier(tier);
  return tier;
}

export function setStoredTier(tier) {
  try {
    localStorage.setItem(PERF_TIER_KEY, tier);
  } catch { /* ignore */ }
}
